import React, { useEffect, useState } from 'react';
import CheckIcon from './CheckIcon';
import WhatsAppIcon from './WhatsAppIcon';
import TopImage from '../../assets/perfume/Design-sem-nome-3-scaled.png';
import './LandingPage.css';

const CTA_LINK = 'https://sndflw.com/i/mbBAdlXgbvKX6IYq39Mn';

const features = [
  'Promoções reais em perfumes',
  'Cupons exclusivos que não aparecem nas lojas',
  'Ofertas por tempo limitado (quem vê primeiro, compra)',
  'Links diretos para lojas oficiais e confiáveis',
  'Devolução gratuita',
  'Sem spam e com total liberdade para sair quando quiser',
];

function handleCTAClick() {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'leads' });
  }
  window.dispatchEvent(new CustomEvent('leads'));
  window.open(CTA_LINK, '_blank', 'noopener,noreferrer');
}

function LandingPage() {
  const [vagas, setVagas] = useState(25);

  useEffect(() => {
    const hoje = new Date().toDateString();
    const ultimoDia = localStorage.getItem('ultimoDia_perfume');
    let novaVaga = 25;

    if (ultimoDia === hoje) {
      const existente = parseInt(localStorage.getItem('vagas_perfume'), 10);
      novaVaga = Number.isNaN(existente) ? 25 : Math.max(3, existente - 1);
    }

    localStorage.setItem('ultimoDia_perfume', hoje);
    localStorage.setItem('vagas_perfume', novaVaga.toString());
    setVagas(novaVaga);
  }, []);

  return (
    <div className="lp-perfume-wrapper">
      {/* ===== SEÇÃO PRINCIPAL ===== */}
      <section className="lp-perfume-hero">
        <div className="lp-perfume-hero-left">
          <div className="lp-perfume-foto-topo">
            <img
              src={TopImage}
              alt="Apresentador Perfumaria"
              className="lp-perfume-foto-img"
            />
          </div>

          <h1 className="lp-perfume-title">
            Te ajudo a <span className="lp-perfume-title-accent">comprar</span>
            <br />
            com <span className="lp-perfume-title-accent">desconto!</span>
          </h1>

          <p className="lp-perfume-subtitle">
            Receba ofertas reais de perfumaria com até{' '}
            <strong>70% OFF</strong> direto no WhatsApp
          </p>

          <button id="buttontop" className="lp-perfume-cta-button" onClick={handleCTAClick}>
            <WhatsAppIcon />
            <span>ACESSAR GRUPO GRATUITO</span>
          </button>

          <p className="lp-perfume-social-proof">
            Mais de <strong>5.000 membros</strong> ativos
          </p>

          <div className="lp-perfume-vagas-badge">
            Restam {vagas} vagas
          </div>
        </div>

        <div className="lp-perfume-hero-right">
          <img
            src="/Media/smartphone.png"
            alt="Grupo do WhatsApp - Perfumaria"
            className="lp-perfume-smartphone-img"
          />
        </div>
      </section>

      {/* ===== SEÇÃO DE FEATURES ===== */}
      <section className="lp-perfume-features">
        <div className="lp-perfume-features-inner">
          <h2 className="lp-perfume-features-title">O que vc encontrará no grupo?</h2>

          <ul className="lp-perfume-features-list">
            {features.map((feature, index) => (
              <li key={index} className="lp-perfume-feature-item">
                <span className="lp-perfume-feature-icon">
                  <CheckIcon />
                </span>
                <span className="lp-perfume-feature-text">{feature}</span>
              </li>
            ))}
          </ul>

          <p className="lp-perfume-vagas-limitadas">Vagas limitadas</p>

          <button id="buttonbotton" className="lp-perfume-cta-button lp-perfume-cta-button--bottom" onClick={handleCTAClick}>
            <WhatsAppIcon />
            <span>ACESSAR GRUPO GRATUITO</span>
          </button>

          <div className="lp-perfume-mobile-smartphone">
            <img
              src="/Media/smartphone.png"
              alt="Smartphone do grupo Perfumaria"
              className="lp-perfume-smartphone-img"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
